/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

import ContentTaskPlanCron from './content-task-plan-cron';

/**
 * @private
 * @typedef {Record<string, *>} Timers TODO #555
 * @typedef {import('../../cron/content-task-cron-factory').ContentTaskCronFactory} ContentTaskCronFactory
 * @typedef {import('../iterator/factory/content-task-plan-iterator-factory').default} ContentTaskPlanIteratorFactory
 */

/**
 * Továrna na "CRON" plánovače obsahových úloh založených na kalendářích
 * @implements {ContentTaskCronFactory}
 */
class ContentTaskPlanCronFactory {
  /**
   * Vytvoří instanci.
   * @param {ContentTaskPlanIteratorFactory} iteratorFactory
   * @param {Timers} timers
   */
  constructor(iteratorFactory, timers) {
    this.iteratorFactory = iteratorFactory;
    this.timers = timers;
  }

  /** @type {ContentTaskCronFactory['create']} */
  create(contentTasks) {
    return new ContentTaskPlanCron(
      contentTasks,
      this.iteratorFactory,
      this.timers
    );
  }
}

export default ContentTaskPlanCronFactory;
